import { Map } from 'immutable';
import { FETCH_CAMPAIGN_PRODUCTS_SUCCESS } from '../actions/actionTypes';

const initialState = Map();

const mapToArrayOfIds = arr =>
  arr.reduce((memo, item) => {
    // TODO: change to id
    const id = item.get('id');
    if (!id) {
      return memo;
    }
    return memo.concat(id);
  }, []);

export function campaign(state = initialState, { type, payload, meta }) {
  switch (type) {
    case FETCH_CAMPAIGN_PRODUCTS_SUCCESS:
      return state.set(meta.id, mapToArrayOfIds(payload));
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/campaign.js